import { PenaltyType } from "api";

export interface Infraction {
    id?: string;
    seasonId: string;
    key: string;
    description: string;
    tableData?: {
        id?: string;
    };
    penaltyType?: PenaltyType;
    stopAndGoTime?: number;
    penaltyPoints?: number;
    penaltyChampPoints?: number;
    penaltyPointsAppliedAfter: number;
    addTimeToEnd: number;
}

export const InfractionDefaultValues: Infraction = {
    seasonId: "",
    key: "",
    description: "",
    stopAndGoTime: 0,
    penaltyPoints: 0,
    penaltyChampPoints: 0,
    penaltyPointsAppliedAfter: 1,
    addTimeToEnd: 0,
};
